export default "__VITE_ASSET__1Yw2hB4h__"